import React, { useState } from "react";
import Panel from "../components/Panel";
import InputField from "../components/InputField";
import ICUCard from "../components/ICUCard";

// Dummy data to illustrate existing ICUs
const dummyICUs = [
  { id: 1, icuName: "General ICU", department: "Medical Intensive Care" },
  { id: 2, icuName: "Neonatal ICU", department: "Pediatrics" },
];

const ICUSetup = () => {
  const [icuName, setIcuName] = useState("");
  const [department, setDepartment] = useState("");
  const [icus, setIcus] = useState(dummyICUs);

  const handleSubmit = (e) => {
    e.preventDefault();
    const newICU = { id: Date.now(), icuName, department };
    setIcus([...icus, newICU]);
    setIcuName("");
    setDepartment("");
  };

  return (
    <Panel title="ICU Setup">
      <form onSubmit={handleSubmit} className="mb-8">
        <InputField
          label="ICU Name"
          value={icuName}
          onChange={(e) => setIcuName(e.target.value)}
          placeholder="Enter ICU name"
        />
        <InputField
          label="Department"
          value={department}
          onChange={(e) => setDepartment(e.target.value)}
          placeholder="Enter ICU department"
        />
        <button
          type="submit"
          className="w-full bg-green-600 text-white py-2 rounded-lg hover:bg-green-700 transition"
        >
          Save ICU
        </button>
      </form>
      <div>
        <h3 className="text-xl font-bold text-gray-800 mb-4">ICU List</h3>
        {icus.length === 0 ? (
          <p className="text-gray-600">No ICU available.</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {icus.map((icu) => (
              <ICUCard key={icu.id} icu={icu} />
            ))}
          </div>
        )}
      </div>
    </Panel>
  );
};

export default ICUSetup;
